import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function relativeTime(input: number | Date | undefined | null): string {
  if (!input) return "—";
  const date = typeof input === "number" ? new Date(input) : input;
  const diff = Date.now() - date.getTime();
  const sec = Math.round(diff / 1000);
  if (Math.abs(sec) < 60) return sec <= 1 ? "just now" : `${sec}s ago`;
  const min = Math.round(sec / 60);
  if (Math.abs(min) < 60) return `${min}m ago`;
  const hr = Math.round(min / 60);
  if (Math.abs(hr) < 24) return `${hr}h ago`;
  const days = Math.round(hr / 24);
  if (Math.abs(days) < 7) return `${days}d ago`;
  return date.toLocaleDateString();
}

export function initials(name: string | undefined | null, fallback = "?") {
  if (!name) return fallback;
  const parts = name.trim().split(/\s+/).slice(0, 2);
  return (parts.map((p) => p[0]).join("") || fallback).toUpperCase();
}

export function slugify(input: string, max = 48): string {
  return input
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, max);
}
